module.exports = __webpack_public_path__ + "static/media/galerija_2019 (41).f7604dfc.jpg";